import { FRONTEND_DEV_GAME_FILE_NAME, LOCAL_ENV } from '../../../../../containers/App/constants'

export function getPlayForFunHref(playForFunURL: string) {
  const forFunPlayUrl = new URL(playForFunURL)

  const localEnvUrl = `/${FRONTEND_DEV_GAME_FILE_NAME}?${forFunPlayUrl.pathname.replace(/[a-z]{2}\//, '')}`

  return LOCAL_ENV ? localEnvUrl : forFunPlayUrl.href
}
